export default __webpack_public_path__ + "static/media/z.8213a8b7.svg";